import { render, staticRenderFns } from "./RfaPage.vue?vue&type=template&id=533a8208&scoped=true"
import script from "./RfaPage.vue?vue&type=script&lang=js"
export * from "./RfaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a8208",
  null
  
)

export default component.exports